import { useMutation } from "react-query";
import { unRegisterSubscription } from "../../../utils/pushNotification";

const useUnregisterNotification = () => {
  return useMutation((token: string) => unRegisterSubscription(token));
};


export default useUnregisterNotification